/** @format */

export const partners = [
	{
		id: 1,
		name: 'Mariamed',
		bio:
			'Centro médico chileno especializado en cannabis medicinal, con 8 años acompañando pacientes desde 2017. Atención médica y psicológica integral, 100% online, con productos de receta magistral autorizados por el ISP, dentro del marco legal vigente.',
		website: 'https://mariamed.cl',
		email: 'contactomariamed@gmail.com',
		phones: ['56954793558'],
		photo: 'https://storage.googleapis.com/tirx-resources-production/e028429f-ec19-4af7-9ec6-4041af03814c.png',
	},
	{
		id: 2,
		name: 'Latinoamérica Reforma (LAR)',
		bio:
			'Fundación sin fines de lucro pionera en Chile en políticas y prácticas sociales sobre cannabis. Su equipo multidisciplinario ofrece consulta médica cannábica presencial y online, asesoría jurídica y apoyo social, con una mirada humana basada en evidencia científica y Derechos Humanos.',
		website: 'https://www.lar.cl/',
		email: null,
		phones: ['56963510104', '56961113512', '56995293315'],
		photo: 'https://storage.googleapis.com/tirx-resources-production/ac1978e2-c0ba-4b5e-915e-0c19c12330f8.png',
	},
	{
		id: 3,
		name: 'Centro Terapéutico Krea',
		bio:
			'Centro de medicina integrativa y salud mental, con atención por telemedicina en todo Chile y presencial en Curicó. Aborda el uso responsable de cannabis, el dolor crónico y la salud mental, en un espacio seguro, inclusivo y cercano.',
		website: null,
		email: null,
		phones: ['56973828154'],
		photo: 'https://storage.googleapis.com/tirx-resources-production/160e2232-9a9f-4e00-90d2-e14b295a1d96.png',
	},
	{
		id: 4,
		name: 'Dr. Meluish Casas',
		bio:
			'Médico cirujano con 11 años de experiencia en el uso terapéutico del cannabis. Combina un sólido conocimiento clínico con un trato cercano, enfocado en mejorar la calidad de vida de cada paciente.',
		website: null,
		email: null,
		phones: ['56987682902'],
		photo: 'https://storage.googleapis.com/tirx-resources-production/3adca7dd-78fd-4d3e-88e5-c4b27157618a.png',
	},
	{
		id: 5,
		name: 'Dr. Diego Cruz Oyarce',
		bio:
			'Médico cirujano (U. de Santiago de Chile), con formación en Urgencia Pediátrica y Máster en Medicina de Montaña (Italia). 14 años de experiencia clínica, los últimos 10 especializado en modulación del sistema endocannabinoide. Docente en cursos y diplomados de Endocannabinología a nivel nacional e internacional.',
		website: null,
		email: 'diegocruzoyarce@gmail.com',
		phones: ['56992800422'],
		photo: 'https://storage.googleapis.com/tirx-resources-production/d92ae5b8-d71e-4e01-9e92-ca107e9d67fe.png',
	},
];

export function formatPhoneDisplay(phone) {
	// 569XXXXXXXX → +56 9 XXXX XXXX
	if (!phone || phone.length < 11) return `+${phone}`;
	return `+${phone.slice(0, 2)} ${phone.slice(2, 3)} ${phone.slice(3, 7)} ${phone.slice(7)}`;
}

export function whatsappUrl(phone, name) {
	const msg = encodeURIComponent(`Hola ${name}, me contacto desde Muy Green para coordinar una evaluación médica.`);
	return `https://wa.me/${phone}?text=${msg}`;
}
